import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Seo from "../../../../../components/seo";
import Layout from "../../../../../layout";
import "../../../../../assets/styles/special_event.scss";
import "../../../../../assets/styles/present_event.scss";
import Heartintune from "../../../../../components/special-event/Heartintune";

const ShiatsuFamilyMassage = () => {
  return (
    <>
      <Seo
        title="Shiatsu Family Massage - Workshop Registration"
        keyword="Shiatsu Family Massage - Workshop Registration"
        description="Shiatsu Family Massage - Workshop Registration"
      />
      <Layout isSticky wrapperClass="special_event divya-janani-banner-wr">
        <div>
          <div className="banner_wrapper bandara_banner_style position-relative">
            <div className="heartfulness-img">
              <StaticImage
                src="../../../../../../static/shiatsu-family-massage-mobile-banner.jpg"
                alt="Meditation event at World's largest meditation center"
                placeholder="blurred"
                className="dynamic-image visible-mobile"
              />
              <StaticImage
                src="../../../../../../static/shiatsu-family-massage-banner.jpg"
                alt="Meditation event at World's largest meditation center"
                placeholder="blurred"
                className="dynamic-image hidden-mobile"
              />
            </div>
          </div>
          <section className="container py-3 my-3">
            <div className="row">
              <div className="col-12">
                <h3>Shiatsu Family Massage - Workshop Registration</h3>
                <p>
                  <i>
                    Saturday 30 Sep 2023: 9:00 am to 1:00 pm; 3:00 pm to 5:00
                    pm; 1 Oct 2023: 9:00 am to 1:00 pm; 3:00 pm to 5:00 pm
                  </i>
                </p>
              </div>
            </div>
            <div className="row" style={{ textAlign: "justify" }}>
              <div className="col-12 mt-4">
                <p>Dear Sisters and Brothers, </p>
                <p>
                  Shiatsu Family Massage is a holistic and therapeutic approach
                  to massage that draws its origins from traditional Japanese
                  healing practices. It emphasizes the principles of touch,
                  pressure, and energy flow to promote relaxation, stress
                  relief, and overall well-being within the context of the
                  family unit.
                </p>
                <p>
                  Based on the concepts of Traditional Chinese Medicine (TCM),
                  Shiatsu Family Massage involves applying rhythmic pressure
                  with fingers, palms, and thumbs to specific points on the
                  body&apos;s energy pathways or meridians. This pressure is
                  aimed at balancing the body&apos;s vital energy, known as
                  &quot;qi&quot; or &quot;chi,&quot; and facilitating the smooth
                  flow of this energy throughout the body. By stimulating these
                  points, practitioners aim to alleviate tension, improve
                  circulation, and support the body&apos;s natural healing
                  mechanisms.
                </p>
                <p>
                  Shiatsu Family Massage is not only a therapeutic practice but
                  also a way for family members to connect, nurture, and care
                  for one another. It can be performed between partners, parents
                  and children, or any family members, providing a bonding
                  experience while offering physical and emotional benefits. The
                  practice can be adapted to various family members&apos; needs
                  and preferences, making it accessible and enjoyable for people
                  of different ages.
                </p>
                <p>
                  During a Shiatsu Family Massage session, individuals are fully
                  clothed and typically lie on a soft surface or sit in a
                  comfortable position. The practitioner uses their hands,
                  fingers, and sometimes even elbows or knees to apply pressure
                  and gentle stretches to the body. The massage is generally
                  soothing and relaxing, promoting a sense of calm and inner
                  balance.
                </p>
                <p>
                  Overall, Shiatsu Family Massage combines the benefits of
                  traditional Japanese healing with modern family dynamics,
                  providing an opportunity for loved ones to come together,
                  experience physical relief, and deepen their emotional
                  connections.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="mb-4">
                  {/* <p>
                    <strong>Course Details</strong>
                  </p> */}
                  <p className="pb-1 mb-0">
                    <strong>Language:</strong> French and English
                  </p>
                  <p className="pb-1 mb-0">
                    <strong>Timings:</strong> 30 Sep 2023: 9:00 am to 1:00 pm;
                    3:00 pm to 5:00 pm; 1 Oct 2023: 9:00 am to 1:00 pm and 3:00
                    pm to 5:00 pm
                  </p>
                  <p className="pb-1 mb-0">
                    <strong>Venue:</strong> North Conference Halls, Kanha Shanti
                    Vanam
                  </p>
                  <p className="pb-1 mb-0">
                    <strong>Course Fees:</strong> 15000 INR (Non inclusive of
                    food and stay arrangements)
                  </p>
                  <br />
                  <p className="pb-1 mb-0">
                    <strong>
                      <i
                        style={{
                          color: "rgba(190, 150, 81)",
                          fontSize: "18px",
                        }}
                      >
                        *Participation certificates will be provided at the end
                        of the program.
                      </i>
                    </strong>
                  </p>
                  <br />
                  <div className="pb-1 pt-2 mb-0">
                    <strong>Notes: </strong>
                    <ul>
                      <li>
                        <strong>
                          Onsite spot registrations and payments will be open on
                          30 Sep 2023 from 8:00 am onwards.
                        </strong>
                      </li>
                      <li>
                        <strong>
                          Those not registered with heartfulness, kindly carry a
                          valid Government ID proof.
                        </strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Heartintune />
        </div>
      </Layout>
    </>
  );
};

export default ShiatsuFamilyMassage;
